import { useWindowDimensions } from "react-native";

const HORIZONTAL_PADDING = 16;
const GAP = 8;
const TARGET_CELL_WIDTH = 190;

/**
 * The page width and card-grid columns of a public storefront list, shared by the shop
 * (`inventory/[slug]`) and a table's Pull Sheet browse (`browse/[eventId]`).
 *
 * The storefront is also a desktop web page, where an uncapped grid stretches edge to edge (#469),
 * so the content is capped and the grid math runs on the capped width.
 */
export function useStorefrontGrid() {
  const { width: windowWidth } = useWindowDimensions();
  const wide = windowWidth >= 768;
  const maxContentWidth = wide ? 1180 : 640;
  const width = Math.min(windowWidth, maxContentWidth);
  const columns = Math.max(
    2,
    Math.min(5, Math.floor((width - HORIZONTAL_PADDING * 2) / TARGET_CELL_WIDTH)),
  );
  const cellWidth = (width - HORIZONTAL_PADDING * 2 - GAP * (columns - 1)) / columns;
  return {
    /** Desktop width (768pt and up). */
    wide,
    maxContentWidth,
    /** The capped content width. */
    width,
    horizontalPadding: HORIZONTAL_PADDING,
    gap: GAP,
    columns,
    cellWidth,
  };
}
